import { useTranslation } from 'react-i18next';
import {
  IconButton, IconButtonOwnProps,
} from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { SelectField } from '../selectField/selectField';
import { Box } from '../../1-primative';
import { MenuItem } from '../menuItem/menuItem';

export enum CursorDirection {
  PREV = 'PREV',
  NEXT = 'NEXT',
}

interface IPaginationProps {
  perPage?: number;
  onChangePerPage?: (perPage: number) => void;
  showPerPage?: boolean;
  cursor: {
    prev?: string;
    next?: string;
  }
  onCursorChange: (cursor: {
    cursor: string;
    direction: CursorDirection;
  }) => void;
  size: IconButtonOwnProps['size'];
}

const pageSizes = [
  15, 25, 50, 100,
];

export const CursorPagination = ({
  perPage = 15, onChangePerPage, showPerPage = true, cursor, size, onCursorChange,
}: IPaginationProps) => {
  const { t } = useTranslation('shared');

  return (
    <Box display='flex' justifyContent='end' alignItems='center' overflow='hidden' >
      <Box display='flex' alignItems='center' overflow='hidden' gap={1}>
        {
          showPerPage && perPage && onChangePerPage && (
            <SelectField
              label=''
              value={perPage}
              onChange={(e: any) => onChangePerPage(e.target.value)}
              size='small'
              sx={{ p: 0 }}
            >
              {pageSizes.map((v) => <MenuItem value={v}>{v} {t('perPage')}</MenuItem>)}
            </SelectField>
          )
        }
        <IconButton
            aria-label="Go to previous page"
            size={size}
            sx={{ color: '#1D1D1D' }}
            disabled={!cursor.prev}
            onClick={() => {
              if (cursor.prev) onCursorChange({ cursor: cursor.prev, direction: CursorDirection.PREV });
            }}
        >
          <NavigateBeforeIcon fontSize="small"/>
        </IconButton>
        <IconButton
            aria-label="Go to next page"
            size={size}
            sx={{ color: '#1D1D1D' }}
            disabled={!cursor.next}
            onClick={() => {
              if (cursor.next) onCursorChange({ cursor: cursor.next, direction: CursorDirection.NEXT });
            }}
        >
          <NavigateNextIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};
